export const computeGraceEndMs = (startMs: number, rawEndMs: number) => {
  // Honor the full selected slot duration; do not reduce end time
  return Math.max(startMs, rawEndMs);
};

export const msToSeconds = (ms: number) => Math.max(0, Math.floor(ms / 1000));

export const formatDuration = (
  seconds: number,
  format: 'HH:MM:SS' | 'MM:SS' | 'human' = 'MM:SS'
): string => {
  if (!Number.isFinite(seconds) || seconds < 0) seconds = 0;
  const t = Math.floor(seconds);
  const h = Math.floor(t / 3600);
  const m = Math.floor((t % 3600) / 60);
  const s = t % 60;

  // For Schedule.tsx ("1h 30m 10s")
  if (format === 'human') {
    if (t <= 0) return 'now';
    return h ? `${h}h ${m}m ${s}s` : `${m}m ${s}s`;
  }

  // For SessionRoom/MusicPlayer ("01:30:10" or "30:10")
  const mm = String(m).padStart(2, '0');
  const ss = String(s).padStart(2, '0');
  
  if (format === 'HH:MM:SS' || h > 0) {
     if (h > 0) return `${h}:${mm}:${ss}`;
     return `${mm}:${ss}`;
  }
  return `${mm}:${ss}`;
};

export const generateTimeOptions = () => {
  const options = [];
  for (let h = 0; h < 24; h++) {
    for (let m = 0; m < 60; m += 15) {
      const hh = String(h).padStart(2, '0');
      const mm = String(m).padStart(2, '0');
      const value = `${hh}:${mm}`;
      
      // Format for display (12-hour)
      // Create a dummy date to use toLocaleTimeString
      const d = new Date();
      d.setHours(h, m, 0, 0);
      const label = d.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
      
      options.push({ value, label });
    }
  }
  return options;
};
